module.exports = __webpack_public_path__ + "img/40_69_004_300.a08bff02.jpg";